export enum IFsFileType {
    Unknown = 'unknown',
    Image = 'image',
    Image360 = 'image360',
    Video = 'video',
    Video360 = 'video360',
    Audio = 'audio',
    Model3d = 'model3d',
    ImageTarget = 'imagetarget'
}

// Filestore data stored in the content doc
export interface IFsFileData {
    id: string
    type: IFsFileType
    name: string
    /**
     * Video only, and absent means true: everything imported from ZML has been through the HLS
     * pipeline. Only a video saved straight into the project filestore from a downloaded MP4 sets
     * it false, and the runtime then plays `video.mp4` because no playlist was ever written.
     */
    hasHls?: boolean
}
